// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"8cd73454","408":"c9e2e101","453":"141d864c","479":"7b36d7b6","637":"e5ff0c17","699":"5ca4ffe1","778":"89cd492d","821":"0cec88ed"}[chunkId] + ".chunk.js";
};